import React from 'react'
import { Spin, Space } from 'antd'
import { useSelector } from 'react-redux'
import {Loading3QuartersOutlined} from "@ant-design/icons/lib";

const Loading = () => {
    const { isShowLoading } = useSelector((state: any) => {
        return {
            isShowLoading: state.commonReducer.isShowLoading,
        }
    })
    if (isShowLoading) {
        return (
            <div className="page__loading">
                <div className="gtWaving">
                    <Space size="middle">
                        <Spin
                            indicator={<Loading3QuartersOutlined spin style={{ fontSize: 25 }} />}
                            size="large"
                        />
                    </Space>
                </div>
            </div>
        )
    }
    return null
}
export default Loading
